import { __rest, __assign, __awaiter, __generator } from 'tslib';
import { useVuexState } from '@scfe-common/micro-frontend-utils';
import { VueCtxStore, $gt } from '../packages/internals/src/appCtx/index.js';
import '../packages/shared-utils/esm/node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetTag.js';
import '../packages/shared-utils/esm/node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getTag.js';
import '../packages/shared-utils/esm/node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArguments.js';
import '../packages/shared-utils/esm/node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isBuffer.js';
import '../packages/shared-utils/esm/node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isTypedArray.js';
import '../packages/shared-utils/esm/node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isPlainObject.js';
import '../packages/shared-utils/esm/node_modules/.pnpm/dayjs@1.11.10/node_modules/dayjs/dayjs.min.js';
import '../packages/shared-utils/esm/node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isDate.js';
import '../packages/shared-utils/esm/node_modules/.pnpm/dexie@3.2.7/node_modules/dexie/dist/modern/dexie.js';
import '../packages/shared-utils/esm/node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createRound.js';
import { checkHasPermission } from '../packages/shared-utils/esm/safe-get/index.js';
import '../packages/shared-utils/esm/station/index.js';
import '../packages/shared-utils/esm/packages/internals/src/appCtx/index.js';
import '../packages/shared-utils/esm/const/index.js';
import '../packages/shared-utils/esm/region/multiRegion.js';
import '../packages/shared-utils/esm/region/multiRegionUtil.js';
import { l as lodashExports } from '../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/lodash.js';
import React__default, { forwardRef, useRef, useImperativeHandle } from 'react';
import { sendDataToMdap } from 'Shared/utils/tracker';
import { Input, message } from 'ssc-ui-react';
import { OPERATION_SCAN_MODE } from './const.js';
import useScanBehaviorDetection from './hooks/useScanBehaviorDetection.js';
import { blockManualInputPointId } from './utils/mdapReport/blockManualInput.js';

// Fix Me
// const ScanInput: React.FC<ScanInputProps> = forwardRef<ScanInputHandle, ScanInputProps>((props, ref) => {
var ScanInput = forwardRef(function (props, ref) {
    var onChange = props.onChange, onConfirm = props.onConfirm, width = props.width, value = props.value, rest = __rest(props, ["onChange", "onConfirm", "width", "value"]);
    var _a = useScanBehaviorDetection(value), scanEnd = _a.scanEnd, onScanEnded = _a.onScanEnded, getOperationInfo = _a.getOperationInfo;
    var userHasInputPermission = checkHasPermission(VueCtxStore, 'FMS_MANUAL_INPUT');
    var manualInputConfig = useVuexState('systemConfig.manualInputConfig');
    var innerRef = useRef(null);
    useImperativeHandle(ref, function () {
        return {
            focus: function () {
                innerRef.current.focus();
            },
            blur: function () {
                innerRef.current.blur();
            },
            clear: function () {
                innerRef.current.value = '';
            },
            select: function () {
                innerRef.current.select();
            },
            onScanEnded: onScanEnded,
        };
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    var handleManualInputBlocked = function () {
        var toastFn = lodashExports.isFunction(props.manualInputToast) ? props.manualInputToast : message.error;
        var msg = $gt('Manual input is blocked. Please scan the barcode or QR code.');
        toastFn(msg);
        sendDataToMdap(blockManualInputPointId);
        innerRef.current.select();
    };
    var handleOnConfirm = function (e, scanParams) { return __awaiter(void 0, void 0, void 0, function () {
        var block_manual_input, finalSupportBlockManulInputFlag, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 8, , 9]);
                    if (!!props.supportBlockManualInput) return [3 /*break*/, 2];
                    return [4 /*yield*/, onConfirm(e, scanParams)];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
                case 2:
                    if (!(lodashExports.isString(value) && value.trim() === '')) return [3 /*break*/, 4];
                    return [4 /*yield*/, onConfirm(e, scanParams)];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    block_manual_input = manualInputConfig.block_manual_input;
                    finalSupportBlockManulInputFlag = (_a = props.customBlockManualInputFlag) !== null && _a !== void 0 ? _a : block_manual_input;
                    if (!!finalSupportBlockManulInputFlag) return [3 /*break*/, 6];
                    return [4 /*yield*/, onConfirm(e, scanParams)];
                case 5:
                    _b.sent();
                    return [2 /*return*/];
                case 6:
                    if (!userHasInputPermission) {
                        handleManualInputBlocked();
                        return [2 /*return*/];
                    }
                    /**
                     * you will reach this branch when:
                     * 1. set supportBlockManualInput `true` and customBlockManualInputFlag `true`
                     * 2. has the userHasInputPermission
                     * currently, only have two scan mode: scan and manual
                     */
                    if ((scanParams === null || scanParams === void 0 ? void 0 : scanParams.operation_mode) === OPERATION_SCAN_MODE.MANUAL) {
                        handleManualInputBlocked();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, onConfirm(e, scanParams)];
                case 7:
                    _b.sent();
                    return [3 /*break*/, 9];
                case 8:
                    error_1 = _b.sent();
                    console.error('handle on confirm error: ', error_1);
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var onKeydown = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var operationInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(e.key === 'Enter')) return [3 /*break*/, 2];
                    scanEnd();
                    operationInfo = getOperationInfo();
                    return [4 /*yield*/, handleOnConfirm(e, operationInfo)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleOnChange = function (val) {
        if (lodashExports.isFunction(onChange)) {
            onChange(val);
        }
    };
    return (React__default.createElement(Input, __assign({}, rest, { ref: innerRef, value: value, onChange: handleOnChange, style: { width: width || 320 }, onKeyDown: onKeydown })));
});

export { ScanInput as default };
